import * as Yup from 'yup';
import { locales } from '../../constants/main';

export const localeSchema = Yup
  .string()
  .required('Необхідно вказати мову')
  .oneOf(locales, `Мова повинна бути одна з ${locales}`);
